import React, { useState } from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { LoginForm } from './LoginForm'
import { ChangePasswordForm } from './ChangePasswordForm'
import { useAuth } from '../../contexts/AuthContext'

const AuthContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${theme.spacing.md};
`

const AuthContent = styled.div`
  width: 100%;
  max-width: 500px;
`

export const AuthPage: React.FC = () => {
  const { isPasswordRecovery } = useAuth()
  const [isSignUp, setIsSignUp] = useState(false)

  const toggleMode = () => {
    setIsSignUp(!isSignUp)
  }

  return (
    <AuthContainer>
      <AuthContent>
        {isPasswordRecovery ? <ChangePasswordForm /> : <LoginForm onToggleMode={toggleMode} isSignUp={isSignUp} />}
      </AuthContent>
    </AuthContainer>
  )
}
